import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MapService {
  DEFAULT_LAT = 47.171044;
  DEFAULT_LONG = 2.658691;
  DEFAULT_ZOOM = 5;
  DEFAULT_MAX_ZOOM = 19;
  DEFAULT_ZOOM_CONTROL = true;
}
